import z from 'zod';

export const firestoreTimestampClientSchema = z.custom<{
  seconds: number;
  nanoseconds: number;
}>((value) => {
  if (typeof value !== 'object' || value === null) {
    return false;
  }

  const {seconds, nanoseconds} = value as {
    seconds?: unknown;
    nanoseconds?: unknown;
  };

  return typeof seconds === 'number' && typeof nanoseconds === 'number';
});

export interface FirestoreTimestampClient extends z.infer<typeof firestoreTimestampClientSchema> {}
